import React from 'react';
import { useProducts } from '../hooks/useProducts';
import { LiveRates } from './LiveRates';
import { Badge } from './ui/badge';
import { Loader2, Search as SearchIcon } from 'lucide-react';
import { ProductCard } from './ProductCard';

interface HomePageProps {
  searchQuery: string;
}

export function HomePage({ searchQuery }: HomePageProps) {
  const { products, loading } = useProducts('all', searchQuery);

  return (
    <div className="p-3 sm:p-6">
      <LiveRates />
      
      <div className="flex items-center justify-between mb-6 mt-8">
        <div>
          <h2 className="text-2xl font-semibold text-brand-green">
            {searchQuery ? `Search Results for "${searchQuery}"` : 'All Products'}
          </h2>
          <p className="text-sm text-muted-foreground">
            {loading ? 'Searching...' : `Showing ${products.length} products`}
          </p>
        </div>
      </div>

      {loading ? (
        <div className="flex flex-col items-center justify-center py-24 bg-white/50 rounded-2xl border border-dashed border-brand-green/20">
          <Loader2 className="h-12 w-12 text-brand-green animate-spin mb-4" />
          <p className="text-brand-green font-medium">Loading products...</p>
        </div>
      ) : products.length > 0 ? (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
          {products.map((product) => (
            <ProductCard 
              key={product.id} 
              product={product} 
              isFavorite={false}
              onToggleFavorite={() => {}}
            />
          ))}
        </div>
      ) : (
        <div className="flex flex-col items-center justify-center py-24 bg-white/50 rounded-2xl border border-dashed border-brand-green/20">
          <div className="bg-light-grey p-4 rounded-full mb-4">
            <SearchIcon className="h-8 w-8 text-muted-foreground" />
          </div>
          <h3 className="text-xl font-semibold text-brand-green mb-2">No products found</h3>
          <p className="text-muted-foreground">Try adjusting your filters or browse other categories</p>
        </div>
      )}
    </div>
  );
}
